import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const ResultSection = styled.section`
  margin-top: ${({ theme }) => pxToRem(theme.spacing.lg)};
  padding-top: ${({ theme }) => pxToRem(theme.spacing.lg)};
  border-top: ${pxToRem(1)} solid ${({ theme }) => theme.borders.divider};
`;

export const ResultHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${({ theme }) => pxToRem(theme.spacing.md)};
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.md)};

  @media (max-width: 560px) {
    align-items: flex-start;
    flex-direction: column;
    gap: ${({ theme }) => pxToRem(theme.spacing.xs)};
  }
`;

export const ResultTitle = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  font-weight: 600;
`;

export const ResultScore = styled.div`
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  white-space: nowrap;

  strong {
    color: ${({ theme }) => theme.colors.ink};
    font-weight: 600;
  }
`;

export const Questions = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Question = styled.div`
  padding: ${({ theme }) => pxToRem(theme.spacing.md)} 0;
  border-top: ${pxToRem(1)} solid ${({ theme }) => theme.borders.divider};

  &:first-child {
    border-top: 0;
    padding-top: 0;
  }
`;

export const QuestionHead = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${({ theme }) => pxToRem(theme.spacing.md)};
`;

export const QuestionNumber = styled.span`
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xs)};
  font-weight: 500;
`;

export const QuestionState = styled.span<{ $correct: boolean }>`
  color: ${({ theme, $correct }) => ($correct ? theme.colors.successText : theme.colors.dangerText)};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xs)};
  font-weight: 600;
`;

export const QuestionText = styled.div`
  margin-top: ${({ theme }) => pxToRem(theme.spacing.xxs)};
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  font-weight: 500;
  line-height: 1.45;
`;

export const QuestionComment = styled.div`
  margin-top: ${({ theme }) => pxToRem(theme.spacing.xxs)};
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xs)};
  line-height: 1.45;
`;

export const AnswerLine = styled.div<{ $correct?: boolean }>`
  margin-top: ${({ theme }) => pxToRem(theme.spacing.xs)};
  color: ${({ theme, $correct }) => ($correct === false ? theme.colors.dangerText : theme.colors.inkSoft)};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xs)};
  line-height: 1.45;

  strong {
    color: inherit;
    font-weight: 600;
  }
`;

export const AttachmentName = styled.div`
  margin-top: ${({ theme }) => pxToRem(theme.spacing.xs)};
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xs)};
`;
